import { Link } from "@wix/wix-ui-icons-common";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { ToolbarButton } from "./../../_shared/toolbar-button/toolbar-button.js";
const DisplayAsUrlButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  return /* @__PURE__ */ React.createElement(
    ToolbarButton,
    {
      prefix: Link,
      onClick: () => toolbarItem.commands?.click(),
      dataHook,
      tooltip: t("LinkPreview_RemovePreview_Tooltip"),
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  DisplayAsUrlButton
};
//# sourceMappingURL=DisplyAsUrlButton.js.map
